import diamant from 'assets/images/diamant.png';
import sgostu from 'assets/images/sgostu.png';
import ecds from 'assets/images/ecds.png';
import ephan from 'assets/images/ephan.png';
import dancrm from 'assets/images/dancrm.svg';

export const projects = [
  { id: 1, name: 'SGOSTU', logo: sgostu, link: 'https://sgostu.com.ua' },
  { id: 2, name: 'Diamant Elite', logo: diamant, link: 'https://diamant-elite.com' },
  { id: 3, name: 'ECDS', logo: ecds, link: 'https://euro-dance.org' },
  { id: 4, name: 'e-phan', logo: ephan, link: 'https://e-phan.com', nowrap: true },
  { id: 5, name: 'DanCRM', logo: dancrm, link: 'https://dancrm.e-phan.com' },
];
